import { render, staticRenderFns } from "./PackageContent.vue?vue&type=template&id=83e38816&"
import script from "./PackageContent.vue?vue&type=script&lang=js&"
export * from "./PackageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports